import React from 'react';
import SVGInline from 'react-svg-inline';

import styles from './align-buttons.scss';
import elementAlign from './element-alignment';

import AlignLeft from 'ub/icons/align/align-left';
import AlignHorz from 'ub/icons/align/align-horz';
import AlignRight from 'ub/icons/align/align-right';
import AlignTop from 'ub/icons/align/align-top';
import AlignVert from 'ub/icons/align/align-vert';
import AlignBottom from 'ub/icons/align/align-bottom';
import DistHorz from 'ub/icons/align/dist-hor';
import DistVert from 'ub/icons/align/dist-vert';

const ICON_SIZE = '30px';

const AlignButton = ({icon, clickHandler}) => (
  <div
    className={`${styles.actionButton}`}
    onClick={clickHandler}
  >
    <SVGInline
      svg={icon}
      width={ICON_SIZE}
      className={styles.alignIcon}
    />
  </div>
);

AlignButton.propTypes = {
  icon: React.PropTypes.string,
  clickHandler: React.PropTypes.func
};

export default class AlignButtons extends React.Component {
  constructor(props) {
    super(props);

    this.alignLeft = elementAlign.align.bind(elementAlign, 'alignLeft');
    this.alignHorizontally = elementAlign.align.bind(elementAlign, 'alignHorizontally');
    this.alignRight = elementAlign.align.bind(elementAlign, 'alignRight');

    this.alignTop = elementAlign.align.bind(elementAlign, 'alignTop');
    this.alignVertical = elementAlign.align.bind(elementAlign, 'alignVertical');
    this.alignBottom = elementAlign.align.bind(elementAlign, 'alignBottom');
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.group}>
          <AlignButton icon={AlignLeft} clickHandler={this.alignLeft} />
          <AlignButton icon={AlignHorz} clickHandler={this.alignHorizontally} />
          <AlignButton icon={AlignRight} clickHandler={this.alignRight} />
        </div>

        <div className={styles.group}>
          <AlignButton icon={AlignTop} clickHandler={this.alignTop} />
          <AlignButton icon={AlignVert} clickHandler={this.alignVertical} />
          <AlignButton icon={AlignBottom} clickHandler={this.alignBottom} />
        </div>

        {this.props.showDistribution ?
          <div className={styles.group}>
            <AlignButton icon={DistHorz} clickHandler={elementAlign.distributeHorizontal} />
            <AlignButton icon={DistVert} clickHandler={elementAlign.distributeVertical} />
          </div> : null
        }
      </div>
    );
  }
}

AlignButtons.propTypes = {
  showDistribution: React.PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/ui/canvas/align-buttons.jsx